<cap-list-loader [listLoader]="listLoader" [showTotal]="true">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'UebrigeBerechtigte' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>{{"Personalien" | translate}}</th>
    <th>{{"Art" | translate}}</th>
    <th>{{"RechteId" | translate}}</th>
    <th>{{"Recht" | translate}}</th>
    <th>{{"Grundstueck" | translate}}</th>
    @if (!mitHist) {
      <th>{{"Totalflaeche" | translate}}</th>
    }
    @if (!mitHist) {
      <th>{{"Wertquote" | translate}}</th>
    }
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (geschaeft of listLoader?.items; track geschaeft; let i = $index) {
    <tr>
      <td>
        <cap-kompakt-persongb
          [auskunftsperre]="geschaeft.model.personGb.auskunftsperre"
          [capHistinfo]="geschaeft.model.personGb.histInfo"
          [item]="geschaeft.model.personGb"
          [itemMasterId]="geschaeft.model.personGb.id"></cap-kompakt-persongb>
      </td>
      <td [capHistinfo]="geschaeft.model.rechtMaster.version?.histInfo">
        <cap-link
          [histinfo]="geschaeft.model.rechtMaster.version?.histInfo"
          [queryParams]="getQueryParamsRecht(geschaeft.model.rechtMaster)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: geschaeft.model.rechtMaster?.art | translate }">
          {{ geschaeft.model.rechtMaster.art | translate }}
        </cap-link>
      </td>
      <td [capHistinfo]="geschaeft.model.rechtMaster.version?.histInfo">
        <cap-link
          [histinfo]="geschaeft.model.rechtMaster.version?.histInfo"
          [queryParams]="getQueryParamsRecht(geschaeft.model.rechtMaster)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: geschaeft.model.rechtMaster?.art | translate }">
          {{ geschaeft.model.rechtMaster.rechteId | formatRechteId }}
        </cap-link>
      </td>
      <td>
        <cap-link
          [histinfo]="geschaeft.model.rechtMaster.version?.histInfo"
          [queryParams]="getQueryParamsRecht(geschaeft.model.rechtMaster)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: geschaeft.model.rechtMaster?.art | translate }">
          <cap-recht-beschreibung
            [capHistinfo]="geschaeft.model.rechtMaster.version?.histInfo"
            [item]="geschaeft.model.rechtMaster"></cap-recht-beschreibung>
        </cap-link>
      </td>
      <td>
        <cap-kompakt-grundstueck
          [capHistinfo]="geschaeft.model.grundstueck.histInfo"
          [item]="geschaeft.model.grundstueck"
          [navigateTo]="getDetailNavigationFor(geschaeft.model.rechtMaster?.art)"></cap-kompakt-grundstueck>
      </td>
      @if (!mitHist) {
        <td>
          @if (geschaeft.model.grundstueck?.flaecheQuadratMeter) {
            <span> {{ geschaeft.model.grundstueck?.flaecheQuadratMeter | decimalHochkomma }}&nbsp;m² </span>
          }
        </td>
      }
      @if (!mitHist) {
        <td>
          @if (!geschaeft.model.quoteUnbekannt && geschaeft.model.quoteAnStammgrundstueck) {
            <span>
              {{ geschaeft.model.quoteAnStammgrundstueck?.zaehler }}
              /{{ geschaeft.model.quoteAnStammgrundstueck?.nenner }}
            </span>
          }
          @if (geschaeft.model.quoteUnbekannt) {
            <span>
              {{ "eigentumanteil.unbekannt" | translate }}
            </span>
          }
        </td>
      }
    </tr>
  }
</ng-template>
